<template>
  <div>
    <!-- Kids Cards -->
    <v-row class="kids p-3">
      <v-col
        cols="6"
        sm="3"
        class="py-0 mb-4"
        v-for="(st, index) in studentInfo"
        :key="index"
      >
        <v-row
          class="kid"
          :class="st.active == true ? 'active' : ''"
          @click="MakeHimActive(index)"
        >
          <v-col cols="4">
            <img
              :src="st.logo"
              v-if="st.logo"
              alt="student image"
              class="student-image"
            />
            <img
              v-else
              src="../../assets/avatar.png"
              class="student-image"
              alt=""
            />
          </v-col>
          <v-col cols="8">
            <p class="student-name">{{ st.name }}</p>
          </v-col>
          <v-col cols="6" class="py-0" v-if="st.grade">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <p class="student-grade mb-1" v-bind="attrs" v-on="on">
                  {{ splitString(st.grade) }}
                </p>
              </template>
            </v-tooltip>
            <span>{{ st.grade }}</span>
          </v-col>

          <v-col cols="6" class="text-right py-0" v-if="st.class">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <p
                  class="text-right student-class mb-1"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ splitString(st.class) }}
                </p>
              </template>
            </v-tooltip>
            <span>{{ st.class }}</span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <hr />
    <div class="card height-auto v-application--is-ltr text-left">
      <v-row class="mb-7">
        <v-col md="5" sm="12">
          <!-- Acadimice Year -->
          <!-- Acadimice Year -->
          <v-row>
            <v-col cols="4" sm="4" class="academic">
              <label for="academicPeriods" class="label">{{
                $t("Academic Year")
              }}</label>
            </v-col>
            <v-col cols="8" sm="8">
              <v-autocomplete
                id="academicPeriods"
                v-model="selectedAcademicPeriodId"
                :items="academicPeriods"
                item-text="en.name"
                item-value="id"
                solo
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" sm="4" class="academic">
              <label for="Semester" class="label">{{ $t("Semester") }}</label>
            </v-col>
            <v-col cols="8" sm="8">
              <v-autocomplete
                :label="$t('Semester')"
                id="semester"
                v-model="selectedSemester"
                :items="semesters"
                item-text="name"
                item-value="id"
                solo
              ></v-autocomplete>
            </v-col>
          </v-row>
          <!-- Quarter -->
          <v-row>
            <v-col md="4" sm="4" class="">
              <p class="mt-2">Quarter</p>
            </v-col>
            <v-col md="8" sm="8">
              <v-autocomplete
                :label="$t('Quarter')"
                :items="quarters"
                item-text="name"
                item-value="id"
                v-model="selectedQuarter"
                solo
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-col>
        <v-col md="2" cols="12"></v-col>
        <v-col md="5" cols="12"></v-col>
      </v-row>
      <div class="card-body">
        <v-row>
          <v-col cols="12" md="6">
            <v-data-table
              :options.sync="options"
              loading-text="Loading... Please wait"
              :headers="headers"
              :items="items"
              item-key="student_id"
              :show-select="false"
              class="elevation-1 level1 templates"
              text="left"
              hide-default-footer
            >
              <template v-slot:item.name="{ item }">
                <p
                  @click="dowenload(item.media_url)"
                  style="cursor: pointer"
                  class="main-color"
                >
                  {{ item.name }}
                </p>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <!-- :loading="loading" -->
        <!-- v-model="selected" -->

        <!-- ======================================== Pagination ======================================  -->
        <div class="text-center pt-2"></div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import ACL from "../../acl";
export default {
  name: "Certificates",

  data() {
    return {
      options: {
        itemsPerPage: -1,
      },
      headers: [
        {
          text: this.$i18n.t("Certificate"),
          value: "name",
          sortable: true,
        },

        // { text: this.$i18n.t("Actions"), value: "actions", sortable: false },
      ],
      // fileObject: "",
      title: this.$i18n.t("Certificates"),
      itemObject: {},
      items: [],
      studentInfo: [],
      selectedStudent_id: "",
      showErroreMessage: false,
      selectedAcademicPeriodId: "",
      activeAcademicPeriod: "",
      academicPeriods: [],
      semesters: [],
      selectedSemester: "",
      selectedQuarter: "",
      quarters: [],
      // is_parent:ACL.
    };
  },
  watch: {
    selectedAcademicPeriodId: {
      handler() {
        if (this.selectedAcademicPeriodId != "") {
          this.getSemesters();
        }
      },
      deep: true,
    },
    selectedSemester: {
      handler() {
        if (this.selectedSemester != "") {
          this.getQuarters();
        }
      },
      deep: true,
    },
    selectedQuarter: {
      handler() {
        if (this.selectedQuarter != "") {
          this.getAllData();
        }
      },
      deep: true,
    },
  },
  methods: {
    MakeHimActive(index) {
      if (this.studentInfo[index].active != true) {
        this.studentInfo.forEach((student) => {
          student.active = false;
        });
        $(".kid").removeClass("active");
        this.studentInfo[index].active = true;
        $(".kid").eq(index).addClass("active");
        this.selectedStudent_id = this.studentInfo[index].student_id;
        this.selectedChild = this.selectedStudent_id;
        this.getAcademicPeriods();
        // this.getAllData();
      } else {
        this.selectedStudent_id = this.studentInfo[index].student_id;
        this.getAcademicPeriods();
        // this.getAllData();
      }
    },
    getAcademicPeriods() {
      axios
        .get(this.getApiUrl + "/school/showAcademicPeriod?list=yes", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            //the token is a variable which holds the token
          },
        })
        .then((response) => {
          this.academicPeriods = response.data.data;
          this.selectedAcademicPeriodId = this.academicPeriods.find(
            (object) => object.is_active == 1
          ).id;

          this.activeAcademicPeriod = this.selectedAcademicPeriodId;
          // this.semesters = [];
          this.quarters = [];
        });
    },

    getSemesters() {
      if (this.selectedAcademicPeriodId != "") {
        axios
          .get(
            this.getApiUrl +
              "/performance/getSemestersFilter?year_id=" +
              this.selectedAcademicPeriodId,
            {
              headers: {
                Authorization: "Bearer " + localStorage.token,
              },
            }
          )
          .then((response) => {
            this.semesters = response.data.data;
          });
      }
    },
    getQuarters() {
      if (this.selectedSemester != "") {
        axios
          .get(
            this.getApiUrl +
              "/performance/getQuartersPerSemester/" +
              this.selectedSemester,
            {
              headers: {
                Authorization: "Bearer " + localStorage.token,
              },
            }
          )
          .then((response) => {
            this.quarters = response.data.data;

            //  this.filter.quarters =[];
            //   this.selectedQuarter = response.data.data.currntQuarterid;
          });
      }
    },
    getMyChildsInfo() {
      axios
        .get(this.getApiUrl + "/dashboard/parent", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.studentInfo = response.data.data.student_info;
          // console.log(this.studentInfo);
          this.studentInfo.forEach((student) => {
            student.active = false;
          });
          this.studentInfo[0].active = true;
          this.selectedStudent_id = this.studentInfo[0].student_id;
          this.MakeHimActive(0);
          // this.getSubjects();
        });
    },

    getAllData() {
      if (this.selectedQuarter != "") {
        axios
          .get(
            this.getApiUrl +
              "/performance/getCertificates/" +
              this.selectedQuarter +
              "?student_id=" +
              this.selectedStudent_id +
              "&year_id=" +
              this.selectedAcademicPeriodId,
            {
              headers: {
                Authorization: "Bearer " + localStorage.token,
              },
            }
          )
          .then((response) => {
            this.items = [];
            this.items = response.data.data;
            this.loading = false;
          });
      }
    },

    dowenload(cirtificate) {
      window.open(cirtificate, "_blank");
    },
  },
  mounted() {
    if (ACL.Role("Parent")) {
      this.getMyChildsInfo();
    } else {
      this.getAcademicPeriods();
    }

    // this.getQuarters();
    // this.getGrades();
    // this.getClasses();
  },
};
</script>
<style lang="scss" scoped>
@import "../../styles/_variables.scss";
@import "../../styles/_modals.scss";

#wrapper {
  transition: all 0.4s ease 0s;
}

.main-color {
  color: $main-color;
}
.headerTable-div {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  background-color: #fff;

  .custom-header {
    margin-bottom: 0;
  }
}

.center {
  margin-left: 30px !important;
}

.select {
  margin-top: 20px !important;
}
.kids {
  margin-bottom: 20px;
  margin-top: 20px;
  overflow: hidden;
  .kid {
    border: 1px solid #dddddd;
    background-color: #ffffff;
    border-radius: 10px;
    cursor: pointer;
    height: 140px;
    overflow: hidden;

    .student-image {
      width: 60px;
      height: 60px;
      border-radius: 50%;
    }
    .student-name {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      color: #000000;
    }
    .student-grade,
    .student-class {
      color: #000000;
      margin-left: 10px;
    }
  }
  .kid.active {
    background-color: #d8e2ff;
    cursor: default;
  }
}
</style>
